//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";

export default {
    name: "otherOwner",
    components: {
        ImageUploader
    },
    data() {
        return {
            show: false,
            showGender: false,
            actions: [{name: '男', value: 1}, {name: '女', value: 2}],
            data: {
                cardType: 0,
                cardTypeStr: '居民身份证',
                identityImage: {}
            },
            saving: false,
            deliveryRecordId: 0,
            showCardType: false,
            cardTypeActions: [
                {name: '居民身份证'},
                {name: '护照'},
                {name: '军官证'},
                {name: '营业执照'}]
        }
    },
    methods: {
        onCancel() {
            this.showCardType = false
        },
        onSelect(action, index) {
            this.data.gender = action.value;
            this.data.genderStr = action.name;
        },
        onSelect2(action, index) {

            this.data.ownerGender = action.value;
            this.data.ownerGenderStr = action.name;
        },
        checkData() {
            if (!this.data.name && !this.data.phoneNumber && !this.data.cardNum) {
                return true;
            } else {

            }
        },
        onSave() {
            // console.log(this.data)
            // return;
            // if (!this.data.name) {
            //     this.$toast('请输入业主姓名');
            //     return;
            // }
            // if (!this.data.ownerGenderStr && this.data.ownerName !== '无') {
            //     this.$toast('请选择业主性别');
            //     return;
            // }

            // if (!/^1[2-9]\d{9}$/.test(this.data.phoneNumber) && this.data.name !== '无') {
            //     this.$toast('手机号格式无效');
            //     return;
            // }
            // if (!this.data.cardTypeStr) {
            //     this.$toast('请选择证件类型');
            //     return;
            // }
            // if (!this.data.cardNum) {
            //     this.$toast('请输入证件号');
            //     return;
            // }


            if (!this.data.emergencyName) {
                this.$toast('请输入紧急联系人');
                return;
            }
            if (!this.data.emergencyPhone) {
                this.$toast('请输入紧急联系人电话');
                return;
            }
            if (!this.data.genderStr) {
                this.$toast('请选择紧急联系人性别');
                return;
            }
            if (!this.data.relationship) {
                this.$toast('请输入与业主关系');
                return;
            }
            this.data.deliveryRecordId = this.deliveryRecordId;
            this.saving = true;
            abp.ajax.post('/api/services/app/DeliveryRecord/SaveOtherOwner', this.data).then(res => {

                this.$router.push({
                    name: 'deliverData',
                    params: {
                        id: this.deliveryRecordId
                    }
                })

            }).finally(() => {
                this.saving = false
            })
        },
        getOtherOwner() {
            let vm = this;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetOtherOwnerByRecordId?recordId=' + this.deliveryRecordId).then(res => {
                if (res.data.result != null) {
                    vm.data = {}
                    vm.data = res.data.result;
                    vm.data.identityImage = {}

                    if (vm.data.gender === 1) {
                        vm.data.genderStr = '男'
                    } else if (vm.data.gender === 2) {
                        vm.data.genderStr = '女'
                    }
                    if (vm.data.ownerGender === 1) {
                        vm.data.ownerGenderStr = '男'
                    } else if (vm.data.ownerGenderStr === 2) {
                        vm.data.ownerGenderStr = '女'
                    }
                    vm.data.members.forEach(item => {
                        item.identityImage = {}
                    })
                }

            }).finally(() => {

            })
        },

        onCardTypeSelect(item) {
            this.data.cardTypeStr = item.name;
            this.cardType(item.name);
            this.showCardType = false;
        },

        cardType(name) {
            if (name === '居民身份证') {
                this.data.cardType = 0;
            } else if (name === '护照') {
                this.data.cardType = 1;
            } else if (name === '军官证') {
                this.data.cardType = 2;
            } else if (name === '营业执照') {
                this.data.cardType = 3;
            }
        },
        // delOtherOwner(row) {
        //     this.$dialog.confirm({
        //         title: '警告',
        //         message: '确认删除？'
        //     }).then(() => {
        //         abp.ajax.delete('/api/services/app/DeliveryRecord/DeleteOtherOwner', {
        //             params: {
        //                 memberId: row.id,
        //                 recordId: this.deliveryRecordId
        //             }
        //         }).then(res => {
        //             this.getOtherOwner()
        //         })
        //
        //     }).catch(() => {
        //
        //     })
        // }

        // getRecordById() {
        //     var vm = this;
        //     abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.deliveryRecordId).then(res => {
        //         // vm.owner = res.data.result;
        //         vm.deliverRecord = res.data.result;
        //     })
        // }
    },
    created() {
        this.deliveryRecordId = parseInt(this.$route.params.id);
        this.getOtherOwner()
        // this.getRecordById()
    }
}
